<template>
  <div class="container">
    <header_auth title="账户注册" />

    <div class="w clearfix">
      <white-space />
      <white-space />

      <div class="step">
        <el-steps :space="200" :active="step" finish-status="success" align-center>
          <el-step title="填写注册信息"></el-step>
          <el-step title="注册成功"></el-step>
        </el-steps>
      </div>

      <el-form ref="form" :model="form" label-width="0" class="form" :rules="rules" autocomplete="off">
        <template v-show="step == 0">
          <el-form-item prop="mobile">
            <el-input v-model="form.mobile" placeholder="请输入手机号码" autocomplete="new-password">
              <i slot="prepend" class="el-icon-mobile-phone form-label-icon"></i>
            </el-input>
          </el-form-item>

          <el-form-item required prop="password">
            <el-input v-model="form.password" placeholder="请设置登录密码" type="password" autocomplete="new-password">
              <i slot="prepend" class="el-icon-lock form-label-icon"></i>
            </el-input>
          </el-form-item>

          <el-form-item required prop="comfirmpwd">
            <el-input v-model="form.comfirmpwd" placeholder="请确认登录密码" type="password" autocomplete="new-password">
              <i slot="prepend" class="el-icon-lock form-label-icon"></i>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-col :span="15">
              <el-form-item prop="captcha_sms">
                <el-input placeholder="请输入短信验证码" v-model="form.captcha_sms" clearable autocomplete="new-password">
                  <i slot="prepend" class="el-icon-message form-label-icon"></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="float: right;">
              <el-form-item style="height:40px;">
                <el-button
                    ref="get_captcha"
                    class="btn-sms"
                    type="primary"
                    @click="on_captcha"
                    :disabled="count_down > 0 || !form.mobile"
                >
                  {{ count_down ? "请等待" + count_down + "秒" : "获取验证码" }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item prop="checked">
            <el-checkbox v-model="form.checked"></el-checkbox>
            我已阅读并同意
            <a :href="config.agreement_signup" style="color: #FF622B;" target="_blank">《服务条款》</a>
          </el-form-item>

          <el-form-item>
            <el-button
                class="btn-signup"
                type="primary"
                @click="submit"
                :loading="submitting"
                :disabled="!form.mobile || !form.password || !form.comfirmpwd || !form.captcha_sms || !form.checked"
            >立即注册
            </el-button>
          </el-form-item>

          <el-form-item>
            已有账号？
            <router-link to="/login" class="active">直接登录</router-link>
          </el-form-item>
        </template>

        <template v-if="step == 2">
          <div class="success">
            <i class="el-icon-circle-check icon"></i>
            注册成功，正在自动登录...
          </div>
        </template>
      </el-form>
    </div>

    <global-footer />
  </div>
</template>

<script>
import * as Cookies from "js-cookie";
import header_auth from "../components/header_auth";

export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!/^[1][3,4,5,7,6,8,9][0-9]{9}$/.test(value)) {
        callback(new Error("手机号码格式错误"));
      } else {
        callback();
      }
    };

    const validatePwd = (rule, value, callback) => {
      if (value != this.form.password) {
        callback(new Error("确认密码与密码不一致"));
      } else {
        callback();
      }
    };

    const validateChecked = (rule, value, callback) => {
      if (value != true) {
        callback(new Error("请同意该条款"));
      } else {
        callback();
      }
    };

    return {
      submitting: false,
      captcha_visible: false,
      form: {
        device: "pc",
        mobile: "",
        password: "",
        captcha_sms: "",
        name: "",
        checked: true,
        captcha: null,
      },
      step: 0,
      count_down: 0,
      disabled: false,
      presonName: "",
      comfirmpwd: "",
      show: false,
      rules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            validator: validateMobile,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 15,
            message: "长度在 6 到 15 个字符",
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入图片验证码",
            trigger: "blur",
          },
        ],
        captcha_sms: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
        comfirmpwd: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 15,
            message: "长度在 6 到 15 个字符",
            trigger: "blur",
          },
          {
            validator: validatePwd,
            trigger: "blur",
          },
        ],
        checked: [
          {
            required: true,
            message: "请选择同意条款",
            trigger: "blur",
          },
          {
            validator: validateChecked,
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {header_auth},
  created() {
    this.time = 60;
  },
  methods: {
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submitting = true;

          //utm广告参数
          this.form["utm"] = Cookies.get("utm");

          this.$http
              .post("auth/signup", {
                ...this.form,
                scope: "mobile_signup",
                onclick_level: 6,
              })
              .then((response) => {
                if (response.success) {
                  //百度代码
                  this.step = 2;

                  window.location.replace("/");
                } else {
                  this.$alert(response.message, "失败", {
                    type: "error",
                    showCancelButton: false,
                  });

                  //this.resetForm();
                }
              })
              .catch(() => {
              })
              .then(() => {
                this.submitting = false;
              });
        } else {
          return false;
        }
      });
    },
    on_captcha() {
      if (this.form.mobile == "") {
        this.$alert("手机号码不能为空", "输入错误", {
          type: "error",
        });
        return false;
      }

      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.mobile)) {
        this.$alert("手机号码格式错误", "输入错误", {
          type: "error",
        });

        return false;
      }

      this.get_captcha();
      // this.$event_bus.$emit("captcha_verify", (e) => {
      //     this.form.captcha = e;
      //     this.get_captcha();
      // });
    },
    get_captcha() {
      this.count_down = 60;

      let loading_instance = this.$loading({
        text: "正在发送验证码...",
      });

      this.$http
          .post("auth/captcha/sms", {
            mobile: this.form.mobile,
            scope: "mobile_signup",
            captcha: this.form.captcha,
          })
          .then((response) => {
            if (response.success) {
              this.$alert("请查看手机短信验证码", "验证码发送成功", {
                confirmButtonText: "确定",
                type: "success",
                callback: (action) => {
                },
              });

              var timer = setInterval(() => {
                this.count_down--;
                if (this.count_down == 0) {
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.count_down = 0;
              this.$alert(response.message, "验证码发送失败", {
                confirmButtonText: "确定",
                type: "error",
              });
            }
          })
          .catch(() => {
            this.count_down = 0;
          })
          .then(() => {
            loading_instance.close();
          });
    },
  },
};
</script>

<style scoped lang="less">
.container {
  .w {
    height: calc(100vh - 290px);
    min-height: 700px;

    .step {
      margin: 48px auto;

      .el-steps {
        max-width: 350px;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .success {
      display: flex;
      flex-direction: column;
      text-align: center;

      .icon {
        font-size: 60px;
        margin-bottom: 24px;
        color: #ff622b;
      }
    }

    .form {
      width: 415px;
      margin: 0 auto;

      .form-label-icon {
        font-size: 18px;
      }

      .btn-sms,
      .btn-signup,
      .btn-reset {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
